import React from "react";

interface FilterModalProps {
  filterDivContainer: string;
  filterPillDiv: string;
  filterPill: string;
  filterButtonDivStyle: string;
  filterDivToggleId: string;
  filterDivButtonStyle: string;
  sortKeys: string[];
  activeFilters: string[];
  toggleFilter: (key: string) => void;
  toggle: (id: string) => void;
}

export const FilterModal: React.FC<FilterModalProps> = ({
  filterDivContainer,
  filterPillDiv,
  sortKeys,
  activeFilters,
  filterPill,
  filterButtonDivStyle,
  filterDivButtonStyle,
  filterDivToggleId,
  toggleFilter,
  toggle,
}) => {
  return (
    <div className={filterDivContainer}>
      <div className={filterPillDiv}>
        {sortKeys.map((key) => {
          const bgColor = activeFilters.includes(key)
            ? "bg-blue-500"
            : "bg-blue-300";
          return (
            <button
              key={key}
              className={`${filterPill} ${bgColor}`}
              onClick={() => toggleFilter(key)}
            >
              {key}
            </button>
          );
        })}
      </div>
      <div className={filterButtonDivStyle}>
        <button
          className={filterDivButtonStyle}
          onClick={() => toggle(filterDivToggleId)}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default FilterModal;
